import React, {useContext, useEffect, useState} from 'react';
import {Box, Grid, IconButton, ListItem, Tooltip, Typography, useToastProvider} from '@deere/fuel-react';
import {toDisplayName} from "../shared/utils";
import {useAuthConfig} from "../shared/helper";
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {CHANGE_COMMENT_VISIBLE, NO_COMMENTS} from "../shared/Constants";
import {RolesContext, UnitsContext} from "./Ratings";

export const RatingYesNoFeedback = ({
                                        feedback,
                                        itemIndex,
                                        criteria,
                                        isActionsAllowed,
                                        updateVisibilityState,
                                        isSupplierMimic,
                                        isSupplierAdmin
                                    }) => {
    let authAxios = useAuthConfig();
    const {enqueueToast} = useToastProvider();
    const [rolesArr, setRolesArr] = useState([])
    const [unitsArr, setUnitsArr] = useState([])
    const [rolesArrString, setRolesArrString] = useState("")
    const [unitsArrString, setUnitsArrString] = useState("")
    const units = useContext(UnitsContext);
    const roles = useContext(RolesContext);
    const name = toDisplayName(feedback.stakeholder.user.firstName, feedback.stakeholder.user.lastName)

    const [commentVisibility, setCommentVisibility] = useState(feedback.feedback.isCommentVisible);

    const handleVisibility = (period, supplierNumber, commentId, feedbackId, criteriaId, visibilityInd) => {
        let putData = {
            period: period,
            supplierNumber: supplierNumber,
            id: commentId,
            feedbackId: feedbackId,
            criteriaId: criteriaId,
            visibilityInd: visibilityInd,
            responseType: 1
        }
        authAxios.put(`/commentsVisibility`, putData)
            .then(res => {
                updateVisibilityState(res.data)
                setCommentVisibility(res.data.visibilityInd)
                enqueueToast({
                    variant: "success",
                    title: "Comment visibility Updated Successfully",
                    isCloseable: true
                });
            }).catch((e) => {
            enqueueToast({
                variant: "error",
                title: "Error updating comment visibility",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        })
    }

    useEffect(() => {
        const tempRolesArr = feedback.stakeholder.roleId.map(item => {
            const filteredArr = roles.filter(ele => ele.id === item)
            return filteredArr.length > 0 && filteredArr[0]["description"]
        })
        const tempUnitsArr = feedback.stakeholder.unitId.map(item => {
            const filteredArr = units.filter(ele => ele.id === item)
            if (filteredArr.length > 0)
                return filteredArr[0]["description"]
            else
                return item
        })

        setRolesArr(tempRolesArr)
        setUnitsArr(tempUnitsArr)
        setRolesArrString(tempRolesArr.length !== 0 ? tempRolesArr.join(', ') : "")
        setUnitsArrString(tempUnitsArr.length !== 0 ? tempUnitsArr.join(', ') : "")

        return () => {
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [feedback]) // eslint-disable-next-line react-hooks/exhaustive-deps

    return (
        <>
            {((isActionsAllowed && !isSupplierMimic) || ((!isActionsAllowed || isSupplierMimic) && feedback.feedback.yesNoChoice !== "")) &&
            <ListItem divider style={{padding: '.5rem 0rem'}} key={`${itemIndex}yesno`}>
                <Grid container
                      alignItems="center"
                >
                    {isActionsAllowed && !isSupplierMimic && (
                        <>
                            {(feedback.feedback.notApplicable === false && feedback.feedback.declined === false && feedback.feedback.comment !== "") ?
                                <Grid item xs={1} style={{maxWidth: '5%'}}>
                                    {commentVisibility ?
                                        <Tooltip
                                            title={CHANGE_COMMENT_VISIBLE}
                                            placement="bottom-start"
                                        >
                                            <IconButton aria-label="visibility" onClick={() => {
                                                handleVisibility(feedback.year,
                                                    feedback.supplierNumber,
                                                    feedback.feedback.commentId,
                                                    feedback.feedback.feedbackId,
                                                    criteria.id, false)
                                            }}>
                                                <VisibilityIcon style={{color: " #367c2b"}}/>
                                            </IconButton>
                                        </Tooltip>
                                        :
                                        <Tooltip
                                            title={CHANGE_COMMENT_VISIBLE}
                                            placement="bottom-start"
                                        >
                                            <IconButton aria-label="visibility_hide" onClick={() => {
                                                handleVisibility(feedback.year,
                                                    feedback.supplierNumber,
                                                    feedback.feedback.commentId,
                                                    feedback.feedback.feedbackId,
                                                    criteria.id, true)
                                            }}>
                                                <VisibilityOffIcon style={{color: "#ccc"}}/>
                                            </IconButton>
                                        </Tooltip>
                                    }
                                </Grid> :
                                <Grid item xs={1} style={{maxWidth: '5%'}}/>
                            }
                        </>
                    )}
                    <Grid item xs={isActionsAllowed && !isSupplierMimic ? 11 : 12}
                          style={isActionsAllowed && !isSupplierMimic ? {
                              maxWidth: '95%',
                              flexBasis: '95%'
                          } : {paddingLeft: "2rem"}}>
                        <Grid container alignItems="center">
                            {(feedback.feedback.notApplicable === false && feedback.feedback.declined === false && feedback.feedback.yesNoChoice !== "") ?
                                <Grid item xs={8}>
                                    <Box display="flex"
                                         justifyContent="flex-start">
                                        {feedback.feedback.comment ?
                                            <>
                                                {commentVisibility ?
                                                    <Typography color="primary">
                                                        {feedback.feedback.comment}
                                                    </Typography>
                                                    :
                                                    <Typography color="tertiary">
                                                        {(isSupplierAdmin && !isSupplierMimic) ? feedback.feedback.comment : ""}
                                                    </Typography>
                                                }
                                            </> :
                                            <Typography color="tertiary">
                                                {isSupplierAdmin ? NO_COMMENTS : ""}
                                            </Typography>
                                        }
                                    </Box>
                                </Grid> :
                                <Grid item xs={8}/>
                            }
                            <Grid item xs={4}>
                                {(feedback.feedback.notApplicable === false && feedback.feedback.declined === false && feedback.feedback.yesNoChoice !== "") ?
                                    <Box display="flex"
                                         justifyContent="flex-end">
                                        <Typography size="md" fontWeight="bold"
                                                    component="p"
                                                    display="inline">
                                            &nbsp; {feedback.feedback.yesNoChoice === 'Y' ? "Yes" : feedback.feedback.yesNoChoice === 'N' ? "No" : ""}
                                        </Typography>
                                    </Box> :
                                    <Box display="flex"
                                         justifyContent="flex-end">
                                        {feedback.feedback.declined === true && (
                                            <Typography size="md"
                                                        fontWeight="semibold">
                                                Declined
                                            </Typography>
                                        )}
                                        {feedback.feedback.notApplicable === true && (
                                            <Typography size="md"
                                                        fontWeight="semibold">
                                                Not Applicable
                                            </Typography>
                                        )}
                                        {(feedback.feedback.notApplicable === false && feedback.feedback.declined === false && feedback.feedback.yesNoChoice === "") && (
                                            <Typography size="md"
                                                        color="tertiary">
                                                No Response
                                            </Typography>
                                        )}
                                    </Box>
                                }
                            </Grid>
                            <Grid item xs={8}>
                                <Box display="flex" justifyContent="flex-start">
                                    {rolesArrString.concat(name).length > 90 ?
                                        <Tooltip
                                            title={rolesArrString}
                                            placement="bottom-start"
                                        >
                                            <Typography color="secondary"
                                                        size="sm" style={{
                                                width: 500,
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                overflow: "hidden"
                                            }}>
                                                {name} | {rolesArr.join(', ')}
                                            </Typography>
                                        </Tooltip>
                                        :
                                        <Typography color="secondary" size="sm">
                                            {name} | {rolesArr.join(', ')}
                                        </Typography>
                                    }
                                </Box>
                            </Grid>
                            <Grid item xs={4}>
                                <Box display="flex" justifyContent="flex-end">
                                    {unitsArrString && unitsArrString.concat(feedback.year).length >= 40 ?
                                        <Tooltip
                                            title={unitsArrString}
                                            placement="bottom-start"
                                        >
                                            <Typography color="secondary"
                                                        size="sm" style={{
                                                width: 250,
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                overflow: "hidden"
                                            }}>
                                                {feedback.year ? `${feedback.year}` : ""} {feedback.year && (unitsArr.length > 0 || unitsArrString !== "") ? "|" : ""} {" "}{unitsArrString}
                                            </Typography>
                                        </Tooltip>
                                        :
                                        <Typography color="secondary" size="sm">
                                            {feedback.year ? `${feedback.year}` : ""} {feedback.year && (unitsArr.length > 0 || unitsArrString !== "") ? "|" : ""} {" "}{unitsArrString}
                                        </Typography>
                                    }
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ListItem>
            }
        </>
    )
}
